import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Form } from "react-bootstrap";
import { DeleteApi, GetApi, PatchApi, PostApi } from "./Helper/Axios";
import { Formik, Field, Form as FormikForm, useFormik } from "formik";

export default function Plan() {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null); // Track the ID of the plan being edited

  const token = localStorage.getItem("token");

  // Fetch all plans
  const getAll = async () => {
    const url = `plans`;
    try {
      const res = await GetApi(url, token);
      console.log("API Response:", res.data);
      setData(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (err) {
      console.error("Error fetching data:", err);
      setData([]);
    }
  };

  // Handle Add or Edit Plan
  const formik = useFormik({
    initialValues: {
      name: "",
      price: "",
      duration_type: "",
      coin_reward: "",
      discount: "",
      sku: "",
      package_name: "",
      image: "",
      is_Ad_free: false,
      is_unlimited_video: false,
      status: true,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log("Form values:", values);

      const token = localStorage.getItem("token");
      console.log(token);
      if (!token) {
        console.error("Token not found");
        return; // Prevent submitting if token is missing
      }

      let url = editId ? `plan/${editId}` : `plan`;
      try {
        let res;
        if (editId) {
          res = await PatchApi(url, values, true, token);
        } else {
          res = await PostApi(url, values, true, token);
        }
        console.log("Response:", res.data);
        getAll();
        setShowModal(false);
        setEditId(null);
      } catch (err) {
        console.error("Error submitting plan:", err);
      }
    },
  });

  const handleEdit = (plan) => {
    setEditId(plan.id);
    formik.setValues({
      name: plan.name,
      price: plan.price,
      duration_type: plan.duration_type,
      coin_reward: plan.coin_reward,
      sku: plan.sku,
      discount: plan.discount,
      image: plan.image,
      package_name: plan.package_name,
      is_Ad_free: plan.is_Ad_free,
      is_unlimited_video: plan.is_unlimited_video,
      status: plan.status,
    });
    setShowModal(true);
  };

  // Handle delete plan
  const handleDelete = async (id) => {
    const url = `plan/${id}`;
    try {
      const res = await DeleteApi(url, null, false, token);
      console.log("Deleted plan response:", res.data);
      getAll();
    } catch (err) {
      console.error("Error deleting plan:", err);
    }
  };

  useEffect(() => {
    getAll();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Plans</h2>
        <Button onClick={() => setShowModal(true)}>Add Plan</Button>
      </div>

      <Table className="mytable">
        <thead>
          <tr>
            <td>ID</td>
            <td>Name</td>
            <td>Price</td>
            <td>Duration Type</td>
            <td>Coin Reward</td>
            <td>Discount</td>
            <td>SKU</td>
            <td>Package Name</td>
            <td>Ad Free</td>
            <td>Unlimited Video</td>
            <td>Status</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(data) &&
            data.map((item, index) => (
              <tr key={index}>
                <td>{item.id}</td>
                <td>{item.name}</td>
                <td>{item.price}</td>
                <td>{item.duration_type}</td>
                <td>{item.coin_reward}</td>
                <td>{item.discount}</td>
                <td>{item.sku}</td>
                <td>{item.package_name}</td>
                <td>{item.is_Ad_free ? "Yes" : "No"}</td>
                <td>{item.is_unlimited_video ? "Yes" : "No"}</td>
                <td>{item.status ? "Yes" : "No"}</td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => handleEdit(item)} // Edit plan
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      {/* Add/Edit Plan Modal */}
      <Modal
        show={showModal}
        animation={false}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{editId ? "Edit Plan" : "Add Plan"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={formik.initialValues}
            enableReinitialize={true}
            onSubmit={formik.handleSubmit}
          >
            <FormikForm className="row">
              {/* <Form.Group className="col-6 mb-3">
                <Form.Label>Image</Form.Label>
                <Field
                  type="file"
                  accept="image/*"
                  name="image"
                  value={formik.values.image}
                  onChange={formik.handleChange}
                  placeholder="Select"
                  className="form-control"
                />
              </Form.Group> */}

              {/* <div className="imageWrapcustum marginright">
                <input
                  type="file"
                  name={field.name}
                  onChange={(e) => {
                    formik.setFieldValue(field.name, e.target.files[0]);
                    setFile(URL.createObjectURL(e.target.files[0]));
                  }}
                />
              </div> */}

              <Form.Group className="col-6 mb-3">
                <Form.Label>Name</Form.Label>
                <Field
                  type="text"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  placeholder="Enter Plan Name"
                  className="form-control"
                />
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Amount</Form.Label>
                <Field
                  type="number"
                  name="price"
                  value={formik.values.price}
                  onChange={formik.handleChange}
                  placeholder="Enter Amount"
                  className="form-control"
                />
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Duration Type</Form.Label>
                <Field
                  name="duration_type"
                  as="select"
                  className="form-control"
                  onChange={formik.handleChange}
                  value={formik.values.duration_type}
                >
                  <option value="">Select Duration</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </Field>
                {/* <Field
                  type="text"
                  name="duration_type"
                  value={formik.values.duration_type}
                  onChange={formik.handleChange}
                  placeholder="Enter Duration Type (e.g., weekly, monthly)"
                  className="form-control"
                /> */}
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Coin Reward</Form.Label>
                <Field
                  type="text"
                  name="coin_reward"
                  value={formik.values.coin_reward}
                  onChange={formik.handleChange}
                  placeholder="Enter Coin Reward"
                  className="form-control"
                />
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Discount</Form.Label>
                <Field
                  type="number"
                  name="discount"
                  value={formik.values.discount}
                  onChange={formik.handleChange}
                  placeholder="Enter Discount"
                  className="form-control"
                />
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>SKU</Form.Label>
                <Field
                  type="text"
                  name="sku"
                  value={formik.values.sku}
                  onChange={formik.handleChange}
                  placeholder="Enter SKU ID"
                  className="form-control"
                />
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Package Name</Form.Label>
                <Field
                  type="text"
                  name="package_name"
                  value={formik.values.package_name}
                  onChange={formik.handleChange}
                  placeholder="Enter Package name"
                  className="form-control"
                />
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Ads Free</Form.Label>
                <Field
                  name="is_Ad_free"
                  as="select"
                  className="form-control"
                  onChange={formik.handleChange}
                  value={formik.values.is_Ad_free}
                >
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </Field>
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Unlimited Video</Form.Label>
                <Field
                  name="is_unlimited_video"
                  as="select"
                  className="form-control"
                  onChange={formik.handleChange}
                  value={formik.values.is_unlimited_video}
                >
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </Field>
              </Form.Group>

              <Form.Group className="col-6 mb-3">
                <Form.Label>Status</Form.Label>
                <Field
                  name="status"
                  as="select"
                  className="form-control"
                  onChange={formik.handleChange}
                  value={formik.values.status}
                >
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </Field>
              </Form.Group>

              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Close
                </Button>
                <Button variant="primary" type="submit">
                  Save Changes
                </Button>
              </Modal.Footer>
            </FormikForm>
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}
